import {C, DEFAULT_PROFILE_SECTION_SETTINGS} from '../contentGenerator/constants';

export {C};

export const CMD_COLORS = [
    {id: 'slate', hex: '#4A5568', light: '#EDF2F7'},
    {id: 'rose', hex: '#C0392B', light: '#FDECEA'},
    {id: 'teal', hex: '#1D9E75', light: '#E1F5EE'},
    {id: 'blue', hex: '#185FA5', light: '#E6F1FB'},
    {id: 'purple', hex: '#534AB7', light: '#EEEDFE'},
    {id: 'amber', hex: '#BA7517', light: '#FAEEDA'},
    {id: 'green', hex: '#1A7A4A', light: '#E2F5EC'},
    {id: 'coral', hex: '#D85A30', light: '#FAECE7'},
];

export const TYPE_CONFIG = {
    title: {
        color: C.blue,
        light: C.blueL,
        label: 'Title',
        fontFamily: "'Playfair Display',Georgia,serif",
        fontSize: 16,
        rows: 2,
    },
    description: {
        color: C.coral,
        light: C.coralL,
        label: 'Description',
        fontFamily: 'inherit',
        fontSize: 13.5,
        rows: 5,
    },
    bullet: {
        color: C.teal,
        light: C.tealL,
        label: 'Bullet',
        fontFamily: 'inherit',
        fontSize: 13.5,
        rows: 3,
    },
    faq: {
        color: C.purple,
        light: C.purpleL,
        label: 'FAQ',
        fontFamily: 'inherit',
        fontSize: 13.5,
        rows: 4,
    },
};

export const STATUS_CONFIG = {
    draft: {label: 'Draft', dot: C.textFaint, bg: C.surfaceAlt, border: C.border, text: C.textSoft},
    revised: {label: 'Revised', dot: C.blue, bg: C.blueL, border: `${C.blue}44`, text: C.blue},
    approved: {label: 'Approved', dot: C.teal, bg: C.tealL, border: `${C.teal}44`, text: C.teal},
    flagged: {label: 'Flagged', dot: C.coral, bg: C.coralL, border: `${C.coral}44`, text: C.coral},
};

export const STATUS_CYCLE = {
    draft: 'approved',
    approved: 'flagged',
    flagged: 'draft',
    revised: 'approved',
};

export const BUILT_IN_TOOLS = [
    {
        id: 'shorten',
        label: 'Shorten',
        color: C.blue,
        prompt:
            'Shorten this text to be more concise without losing its key message or impact. Return only the improved text, nothing else.',
    },
    {
        id: 'punchier',
        label: 'Punchier',
        color: C.purple,
        prompt:
            'Make this text punchier, bolder, and more direct. More confident and impactful. Return only the improved text, nothing else.',
    },
    {
        id: 'expand',
        label: 'Expand',
        color: C.teal,
        prompt:
            'Expand this text with richer detail and more persuasive language while keeping it tight. Return only the improved text, nothing else.',
    },
    {
        id: 'formal',
        label: 'Formal',
        color: C.coral,
        prompt:
            'Rewrite in a refined, professional editorial tone. Return only the improved text, nothing else.',
    },
    {
        id: 'rephrase',
        label: 'Rephrase',
        color: C.amber,
        prompt:
            'Rephrase this completely with fresh language. Same meaning, entirely different expression. Return only the improved text, nothing else.',
    },
    {
        id: 'seo',
        label: 'SEO boost',
        color: C.green,
        prompt:
            'Rewrite this to be more SEO-friendly. Keep the natural tone but ensure key descriptive terms appear naturally. Return only the improved text, nothing else.',
    },
];

export const DEFAULT_CUSTOM_COMMANDS = [
    {
        id: 'cc1',
        label: 'Brand voice',
        colorId: 'slate',
        prompt:
            "Rewrite this in our brand voice: refined, confident, and precise. Avoid generic superlatives. Return only the improved text, nothing else.",
    },
    {
        id: 'cc2',
        label: 'Amazon-ready',
        colorId: 'amber',
        prompt:
            'Rewrite this for Amazon product listings: clear, feature-focused, keyword-rich, and scannable. Use active voice. Return only the improved text, nothing else.',
    },
];

export const DEFAULT_LIMITS = {
    title: DEFAULT_PROFILE_SECTION_SETTINGS.title.maxChars || 0,
    description: DEFAULT_PROFILE_SECTION_SETTINGS.description.maxChars || 0,
    bullet: DEFAULT_PROFILE_SECTION_SETTINGS.bullets.maxChars || 0,
    faq: DEFAULT_PROFILE_SECTION_SETTINGS.faqs.maxAnswerChars || 0,
};

export const FILTER_OPTIONS = [
    {key: 'all', label: 'All'},
    {key: 'pending', label: 'Pending'},
    {key: 'approved', label: 'Done'},
    {key: 'flagged', label: 'Flagged'},
];
